import { UnderlineTooltip } from 'src/UI/common';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { GroupMember, appliesToFullNames, appliesToLabel } from '../grouping';

/**
 * Members are shortened to keep the column one line wide however many share an item; the
 * tooltip carries the full names, which is the only place they can be read in full.
 */
export function AppliesToCell({ members }: { members: GroupMember[] }) {
  if (members.length === 0) return null;

  return (
    <UnderlineTooltip
      label={appliesToFullNames(members)}
      size="xs"
      fw={FONT_WEIGHTS.medium}
      c="black"
    >
      {appliesToLabel(members)}
    </UnderlineTooltip>
  );
}
